import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// Assets
import doctorImg from "../assets/puspakbgremove.png";
// import drps from "../assets/drppskk.gif"; // (optional backdrop circle)

import hero1 from "../assets/orthopics.webp";
import hero2 from "../assets/orthopics2.webp";
import hero3 from "../assets/orthopics3.webp";
import hero4 from "../assets/orthopics4.jpg";

const SLIDE_INTERVAL_MS = 5000;

const Hero = () => {
  const slides = [hero1, hero2, hero3, hero4].filter(Boolean);
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);
  const pausedRef = useRef(false);
  const [isMd, setIsMd] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => setIsMd(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Autoplay
  useEffect(() => {
    start();
    return stop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  const start = () => {
    stop();
    if (!pausedRef.current) {
      timerRef.current = setTimeout(() => {
        setIndex((i) => (i + 1) % slides.length);
      }, SLIDE_INTERVAL_MS);
    }
  };

  const stop = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  const goTo = (i) =>
    setIndex(((i % slides.length) + slides.length) % slides.length);

  return (
    <section
      className="hero-section text-white position-relative d-flex align-items-center"
      style={{
        backgroundImage: `url(${slides[index]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        transition: "background-image 0.6s ease-in-out",
        minHeight: "106vh",
      }}
      onMouseEnter={() => {
        pausedRef.current = true;
        stop();
      }}
      onMouseLeave={() => {
        pausedRef.current = false;
        start();
      }}
    >
      {/* Dark overlay */}
      <div
        aria-hidden
        style={{
          backgroundColor: "#041d29",
          opacity: 0.72,
          position: "absolute",
          inset: 0,
          zIndex: 1,
        }}
      />

      {/* Fade layer */}
      <div
        aria-hidden
        key={index}
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          animation: "heroFade 800ms ease",
        }}
      />

      {/* Content */}
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row align-items-center">
          {/* Left Text */}
          <div className="col-md-7 py-5">
            <div className="badge bg-light text-dark mb-3">❤️ HI I AM</div>
            <h1 className="fw-bold mb-4">
              Meet Prof Dr Puspak Samal — Specialized Care for Bones, Joints &
              Spine.
            </h1>
            <p className="text-light">
              Dr. Puspak Samal is a highly experienced and compassionate
              Orthopaedics & Spine Surgeon dedicated to providing exceptional
              patient care.
            </p>
            <div className="d-flex gap-3 mt-4">
              <a
                href="https://indiahealthsystem.com/"
                className="btn btn-primary"
              >
                BOOK APPOINTMENT <i className="bi bi-arrow-right"></i>
              </a>
              <Link to="/contact" className="btn btn-outline-light">
                SEND MESSAGE <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>

          {/* Right Doctor */}
          <div className="col-md-5 position-relative pt-md-5 pb-md-0 py-5 d-flex justify-content-center">
            <div className="position-relative mt-md-5 mt-0">
              <img
                src={doctorImg}
                alt="Dr. Puspak Samal"
                className="img-fluid position-relative"
                style={{
                  zIndex: 2,
                  maxWidth: "100%",
                  height: "auto",
                  marginTop: isMd ? "120px" : "0",
                }}
              />

              {/* Mission box */}
              <div
                className="position-absolute text-white rounded shadow-lg"
                style={{
                  top: "75%",
                  right: "2%",
                  padding: "1.5rem",
                  maxWidth: 300,
                  boxShadow: "0 30px 40px rgba(0,0,0,0.9)",
                  backgroundColor: "rgba(0, 0, 0, 0.9)",
                  zIndex: 3,
                }}
              >
                <em>
                  My mission is to treat every patient with care, respect, and
                  the highest standard of medical knowledge
                </em>
                <div className="mt-2 text-warning">— Dr. Puspak Samal</div>
              </div>
            </div>
          </div>
        </div>

        {/* Social rail */}
        <div
          className="position-fixed d-flex flex-column align-items-center"
          style={{
            top: "50%",
            right: 0,
            transform: "translateY(-50%)",
            padding: "0.5rem 0.4rem",
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
            zIndex: 1000,
            gap: "0.5rem",
          }}
        >
          <a
            href="https://www.facebook.com/profile.php?id=100093944354071"
            className="text-white d-flex align-items-center justify-content-center rounded-circle"
            style={{ backgroundColor: "#1877F2", width: 40, height: 40 }}
          >
            <i className="bi bi-facebook"></i>
          </a>
          <a
            href="https://wa.me/917873366631"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white d-flex align-items-center justify-content-center rounded-circle"
            style={{ backgroundColor: "#25D366", width: 40, height: 40 }}
          >
            <i className="bi bi-whatsapp"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/dr-puspak-samal-a86771280/?originalSubdomain=in"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white d-flex align-items-center justify-content-center rounded-circle"
            style={{ backgroundColor: "#0A66C2", width: 40, height: 40 }}
          >
            <i className="bi bi-linkedin"></i>
          </a>
          <a
            href="https://www.instagram.com/dr_puspak_samal/"
            className="text-white d-flex align-items-center justify-content-center rounded-circle"
            style={{
              background:
                "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
              width: 40,
              height: 40,
            }}
          >
            <i className="bi bi-instagram"></i>
          </a>
        </div>
      </div>

      {/* Dots */}
      <div
        className="position-absolute d-flex justify-content-center gap-2"
        style={{ bottom: 16, left: 0, right: 0, zIndex: 3 }}
      >
        {slides.map((_, i) => (
          <button
            key={i}
            aria-label={`Go to slide ${i + 1}`}
            onClick={() => goTo(i)}
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              border: 0,
              outline: "none",
              background: i === index ? "white" : "rgba(255,255,255,0.5)",
              cursor: "pointer",
            }}
          />
        ))}
      </div>

      {/* Keyframes */}
      <style>{`
        @keyframes heroFade {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </section>
  );
};

export default Hero;
